import { CommonModule } from "@angular/common";
import { Component, HostBinding, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from "@angular/router";
import { DxButtonModule, DxSelectBoxModule } from "devextreme-angular";
import {
  ItemClickEvent,
  SelectionChangedEvent,
} from "devextreme/ui/select_box";
import { AppGlobals } from "src/app/app.globals";
import { DynamicTableService } from "src/app/services/dynamic-tables.service";

@Component({
    selector: "app-dynamic-tables",
    imports: [CommonModule, DxSelectBoxModule, DxButtonModule, RouterOutlet],
    providers: [DynamicTableService],
    templateUrl: "./dynamic-tables.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./dynamic-tables.component.css"]
})
export class DynamicTablesPage implements OnInit {
  tableId = -1;
  tables: any[] = [];

  @HostBinding('style.padding')
  get hostPadding() {
    return this.router.url.includes('/edit') ? '0' : '16px';
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public appGlobals: AppGlobals,
    private service: DynamicTableService
  ) {}
  async ngOnInit() {
    this.tableId = this.route.snapshot.firstChild?.params["id"];
    this.appGlobals.$headerTitle.next(
      $localize`:@@DynamicTables:Dynamic Tables`
    );
  }
}
